import * as yup from "yup";
import { ReactSelectOption } from "../../models/generic";
import { FormValidationModel } from "../../models/validation";
import { MultiAddModel, MultiAddSchema, ReactSelectOptionSchema } from "../generic";

export interface GradingGroupData {
    active: boolean;
    closesOn: Date | null;
    id: number;
    isAdmin: boolean;
    name: string;
    opensOn: Date | null;
    parent: ReactSelectOption | null;
    reviewers: GradingGroupReviewerData[];
}

export class GradingGroup implements FormValidationModel<GradingGroupData> {
    public data: GradingGroupData;
    public rules: yup.Schema<GradingGroupData>;

    public constructor() {
        this.data = {
            active: true,
            closesOn: null,
            id: 0,
            isAdmin: false,
            name: "",
            opensOn: null,
            parent: null,
            reviewers: [],
        };
        this.rules = yup.object<GradingGroupData>().shape({
            active: yup.bool().label("Active"),
            closesOn: yup.date().nullable(true).required().label("Grading closes on"),
            id: yup.number().required().label("ID").min(0, "Invalid $label"),
            isAdmin: yup.bool().label("Admin group"),
            name: yup.string().required().max(100).label("Name"),
            opensOn: yup.date().nullable(true).required().label("Grading opens on"),
            parent: ReactSelectOptionSchema.nullable(true).label("Parent group"),
            reviewers: yup.array().of(GradingGroupReviewerSchema).label("Reviewers"),
        });
    }
}

export interface GradingGroupReviewerData extends MultiAddModel {
    degrees?: string;
    firstName: string;
    isNew: boolean;
    lastName: string;
    legacyMemberId?: number;
    profilePicture?: string;
    userId: number;
    username: string;
}

export const GradingGroupReviewerSchema = yup.object<GradingGroupReviewerData>().shape({
    ...MultiAddSchema,
    degrees: yup.string().nullable(true),
    firstName: yup.string().nullable(true),
    isNew: yup.bool(),
    lastName: yup.string().nullable(true),
    legacyMemberId: yup.number().nullable(true),
    profilePicture: yup.string().nullable(true),
    userId: yup.number(),
    username: yup.string().nullable(true),
});

export const DefaultGradingGroupReviewer: GradingGroupReviewerData = {
    firstName: "",
    index: 0,
    isDeleted: false,
    isNew: true,
    lastName: "",
    userId: 0,
    username: "",
};



// WEBPACK FOOTER //
// ./src/forms/abstract/GradingGroup.ts